module.exports = __webpack_public_path__ + "img/2020.53180381.png";